export const environment = {
	production: true,
	url: `https://${window.location.hostname}/api/`,
	auth: {
		url: `https://${window.location.hostname}/auth`,
		realm: 'innovation',
		clientId: 'angular-identity-service',
		logoutUri: `https://${window.location.hostname}/sign-out`,
	},
};
